import React, { useEffect, useRef } from "react";
import Odometer from "odometer";
import "odometer/themes/odometer-theme-default.css";
import styles from "./index.module.scss";

interface OdometerCounterProps {
  value: number;
  className?: string;
  format?: string;
  theme?: string;
}

const OdometerCounter: React.FC<OdometerCounterProps> = ({
  value,
  className = "",
  format = "(,ddd)",
  theme = "default",
}) => {
  const odometerRef = useRef<HTMLDivElement>(null);
  const odometerInstance = useRef<any>(null);

  useEffect(() => {
    if (odometerRef.current && !odometerInstance.current) {
      odometerInstance.current = new Odometer({
        el: odometerRef.current,
        value,
        format,
        theme,
        animation: "slide",
      });
    }

    return () => {
      odometerInstance.current = null;
    };
  }, [format, theme, value]);

  useEffect(() => {
    odometerInstance.current?.update(value);
  }, [value]);

  return (
    <div
      ref={odometerRef}
      className={`odometer ${styles.odometerCustom} ${className}`}
    />
  );
};

export default OdometerCounter;
